import type { FC } from 'react'
import { useState } from 'react'

import AddButton from '@/components/AddButton'

import Sidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
}

const AddLandlordReference: FC<Props> = ({ customerId, subjectId }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <Sidebar
          customerId={customerId}
          subjectId={subjectId}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <AddButton onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default AddLandlordReference
